<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" href="#" class="btn btn-rounded btn-info btn-block-xs-only">
            Create New Internal User
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4" 
          v-on:search-data-change="onSearchChange" />
        
      </div>
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange"
        v-on:table-cell-custom="onInternalUserCellRevokeClick" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

      <TemplateModal
        v-bind:modalId="modalId + '-delete'">

        <h4 slot="modal-title" class="modal-title" >
          Revoke Role
        </h4>

        <div slot="modal-body">
          {{ getInternalUserRevokeModalMessage() }}
          <br>
          <TemplateFeedback ref="modalRevokeFeedback" />
        </div>

        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onModalRevokeRole" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>

      </TemplateModal>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import TemplateModal from "@/components/Template/TemplateModal";

import PageInternalUserCellRole from "@/components/Page/Admin/PageInternalUserCellRole"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'name',
    text: 'Name',
    table_popup: true, 
  },
  {
    key: 'email',
    text: 'Email',
    form_email: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'roleID',
    text: 'Role',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (dataItem) => dataItem.title,
    },
    form_edit_hide: true,
    form_edit_validation: [],
  },
  {
    key: 'createDate',
    text: 'Date Created',
    form_hide: true,
    table_custom: helper.tableCustomDatetime,
    form_input_validation: [],
  },
  {
    key: 'title',
    text: 'Role',
    table_component: PageInternalUserCellRole,
    form_hide: true,
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageInternalUser",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    TemplateModal,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'People Management' },
        { name: 'Internal User List' },
      ],

      PARAM,
      PARAM_MAP,

      modalId: null,
      modalRevokeRole: null,

      pageUser: null,
      pageRole: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.modalId = "jt-popup-modal-" + this._uid;

    this.loadRole();
  },
  methods: {
    loadRole() {
      this.$refs['pageTable'].setTableLoading('Loading role data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/roles/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageRole = response.data;
          helper.inputSelectSetOption(this.PARAM_MAP['roleID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'role data'));
        })
    },
    loadData() {
      let url = this.getUrl();
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      this.$refs['pageTable'].setTableLoading('Loading internal user data...');
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);

          let tempUser = {};
          response.data.forEach(k => {
            if(tempUser[k['username']]) {
              return;
            }
            tempUser[k['username']] = k;
            k['email'] = k['username'];
          });
          
          this.pageUser = Object.values(tempUser);

          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.userID);
          // helper.inputSelectSetOption(this.PARAM_MAP['userID'], response.data);
          // this.loadData();
          // this.$refs['pageTable'].setTableData(this.pageUser);
          this.loadUserRole();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'internal user data'));
        })
    },
    async loadUserRole() {
      for(let k of this.pageUser) {
        k._roles = [];

        if(!await this.$http
          .get(
            helper.SERVER_URL + '/api2/staff/' + k.staffID + '/roles',
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            response.data.forEach(j => {
              if(j.roleID) {
                k._roles.push(j);
              }
            });
            return true;
          })
          .catch(error => {
            this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'internal user data'));
          })
        ) {
          return;
        }
      }

      this.$refs['pageTable'].setTableData(this.pageUser);
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/staff/';
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add New Internal User');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },
    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    async onModalAddDataClick(selectedData) {
      // if(this.pageUserRole.some(k => k.email === selectedData.email)) {
      //   this.$refs['pageModal'].setModalError('Entered email already belongs to a user');
      //   return;
      // }
      // if(this.pageUserRole.some(k => k.name === selectedData.name)) {
      //   this.$refs['pageModal'].setModalError('Entered name already belongs to a user');
      //   return;
      // }
      if(this.pageUser.some(k => k.email === selectedData.email && k.roleID === selectedData.roleID)) {
        this.$refs['pageModal'].setModalError('Entered user already has this role.');
        return;
      }

      let feedbackItem = 'internal user ' + selectedData.email;
      this.$refs['pageModal'].setModalLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    async onModalEditDataClick(selectedData) {
      let feedbackItem = 'internal user ' + selectedData.email;
      this.$refs['pageModal'].setModalLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          this.getUrl() + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem); 
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    onModalDeleteDataClick(selectedData) {
      let feedbackItem = 'internal user ' + selectedData.email;
      this.$refs['pageModal'].setModalLoading('Deleting ' + feedbackItem);
      this.$http
        .delete(
          this.getUrl() + selectedData.id,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', feedbackItem));
        })
    },
    onInternalUserCellRevokeClick(role) {
      this.modalRevokeRole = role;
      this.$refs['modalRevokeFeedback'].setFeedbackMessage();
      $('#' + this.modalId + '-delete').modal('show');
    },
    getInternalUserRevokeModalMessage() {
      if(this.modalRevokeRole) {
        return `Are you sure you want to revoke role [${this.modalRevokeRole.title}] from ${this.modalRevokeRole.username}?`
      }
      return '';
    },
    onModalRevokeRole() {
      let feedbackItem = 'role from internal user';
      this.$refs['modalRevokeFeedback'].setFeedbackLoading('Revoking ' + feedbackItem);
      this.$http
        .delete(
          helper.SERVER_URL + '/api2/staff/' + this.modalRevokeRole.staffID + '/roles/' + this.modalRevokeRole.userRoleID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);

          $('#' + this.modalId + '-delete').modal('hide');
          this.$refs['modalRevokeFeedback'].setFeedbackMessage();
          this.modalRevokeRole = null;

          this.loadData();
        })
        .catch(error => {
          this.$refs['modalRevokeFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'revoking', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageInternalUser.vue